import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/store-app';
import router from './modules/store-routers';
import user from './modules/store-user';
import tagsView from './modules/store-tags-view';
import menuRemind from './modules/store-menu-remind';
import workPlantEntry from './modules/store-work-plant-entry';
import showLeft from './modules/store-nav-show-left';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        app,
        router,
        user,
        tagsView,
        menuRemind,
        workPlantEntry,
        showLeft
    },
    getters
});



// WEBPACK FOOTER //
// ./src/store/index.js